/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ArrowRightIcon = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 53 100", fill: "currentColor", width: size || '1em', height: size || '1em', ...props },
    React.createElement("path", { fill: "currentColor", d: "M5.16 99.14L2.15 96.13 48.6 50.11 2.15 4.3 5.16 1.29 54.62 50.11" })));
ArrowRightIcon.displayName = 'ArrowRightIcon';
export default ArrowRightIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowRightIcon.js.map